<template>
  <div class="error-container">
    <i class="fas fa-exclamation-circle error-icon"></i>
    <p class="error-message">{{ error }}</p>
    <button @click="$emit('retry')" class="retry-button">
      <i class="fas fa-redo"></i> Retry
    </button>
  </div>
</template>

<script>
export default {
  name: 'ErrorState',
  props: {
    error: {
      type: String,
      required: true
    }
  },
  emits: ['retry']
};
</script>

<style scoped>
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background: var(--bg-white);
  border-radius: var(--radius-lg);
  margin: 2rem 0;
  box-shadow: var(--shadow-lg);
  text-align: center;
}

.error-icon {
  font-size: 2rem;
  color: #ef4444;
  margin-bottom: 0.7rem;
}

.error-message {
  color: var(--text-medium);
  font-size: 1rem;
  margin: 0;
  max-width: 600px;
  line-height: 1.6;
  font-weight: 500;
}

.retry-button {
  margin-top: 2rem;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  border: none;
  border-radius: var(--radius-xl);
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: var(--transition);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.retry-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  background: linear-gradient(135deg, var(--secondary-color), var(--primary-color));
}
</style> 